export { default } from './PartnersPage';
